import { gql, useMutation } from "@apollo/client";
import { useCallback } from "react";
import { errorFragment } from "../../../../../gql/GqlErrorFragment";
import {
  DeleteHeadAgreementMutation,
  DeleteHeadAgreementMutationVariables,
} from "@/gql/graphql";

const mutation = gql`
  ${errorFragment}
  mutation DeleteHeadAgreement($headAgreementId: ID!, $rowVersion: String!) {
    productPrice {
      headAgreement {
        deleteHeadAgreement(
          headAgreementId: $headAgreementId
          rowVersion: $rowVersion
        ) {
          ... on ErrorResult {
            ...ErrorFragment
          }
          ... on DeleteHeadAgreementSuccessResult {
            customer {
              id
              preselectedHeadAgreement {
                id
              }
            }
          }
        }
      }
    }
  }
`;
export const useDeleteHeadAgreementMutation = () => {
  const [mutate, { loading, error }] = useMutation<
    DeleteHeadAgreementMutation,
    DeleteHeadAgreementMutationVariables
  >(mutation, {
    update(cache, { data }) {
      const result = data?.productPrice.headAgreement.deleteHeadAgreement;
      if (result?.__typename === "DeleteHeadAgreementSuccessResult") {
        const customerId = result.customer.id;
        if (customerId) {
          cache.evict({
            id: cache.identify({ __typename: "Customer", id: customerId }),
          });
          cache.gc();
        }
      }
    },
  });

  const deleteHeadAgreement = useCallback(
    (headAgreementId: string, rowVersion: string) =>
      mutate({ variables: { headAgreementId, rowVersion } }),
    [mutate]
  );

  return { deleteHeadAgreement, loading, error };
};
